<template>
  <div class="forgot_pwd_css">
    <el-row type="flex"
            style="height: 100%;"
            align="middle"
            justify="center">
      <div style="height: 500px;box-shadow:0 0 15px rgba(236,249,247,0.2);overflow: hidden;">
        <div style="display:inline-block;height: 100%;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_left.png" />
        </div>
        <div style="display:inline-block;height: 100%;position: relative;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_right.png" />
          <div style="position: absolute;top:0;left:0;width:100%;height: 100%;"
               v-loading="loading">
            <div class="register-box">
              <div style="display:flex;align-items:flex-end;justify-content:flex-start;border-bottom:1px solid #eaeaea;">
                <div class="tab-bar-item">重置登录密码</div>
              </div>
              <div class="input-form">
                <el-form ref="userInfo"
                         class="myform"
                         :model="userInfo"
                         :rules="formRules">
                  <el-form-item prop="phone">
                    <el-input v-model="userInfo.phone"
                              @keyup.enter.native="$refs.pass.focus()"
                              placeholder="请输入手机号码">
                      <i slot="prefix"
                         class="el-icon-mobile-phone"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="userInfo.password"
                              show-password
                              ref="pass"
                              @keyup.enter.native="$refs.pass2.focus()"
                              auto-complete="new-password"
                              placeholder="请输入密码">
                      <i slot="prefix"
                         class="el-icon-lock"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password2">
                    <el-input v-model="userInfo.password2"
                              show-password
                              ref="pass2"
                              @keyup.enter.native="$refs.yzm.focus()"
                              auto-complete="new-password"
                              placeholder="请再次输入密码">
                      <i slot="prefix"
                         class="el-icon-lock"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="yzm">
                    <el-input v-model="userInfo.yzm"
                              :maxlength="6"
                              style="width:calc(100% - 135px);"
                              placeholder="请输入验证码">
                      <span slot="prefix"
                            style="font-size: 16px;">#</span></el-input>
                    <el-button style="margin-left:15px;width:120px;"
                               :disabled="!!mInterval"
                               @click="getYzm()">{{yzmText}}</el-button>
                  </el-form-item>
                  <el-form-item style="margin-bottom:10px;">
                    <el-button type="primary"
                               :disabled="canRegister"
                               style="width:100%;margin-top:0px;"
                               @click="submitForm()">确定</el-button>
                  </el-form-item>
                </el-form>
                <div style="text-align: right;margin-top: 15px;">
                  <div @click="toLogin"
                       style="display: inline-block;"
                       class="text-btn">返回登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!(/^1(2|3|4|5|6|7|8|9)\d{9}$/.test(value))) {
        callback(new Error('请输入正确的11位手机号'));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      }
      let yz = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,20}$/;
      if (!yz.exec(value)) {
        callback(new Error('密码必须为8-20位数字+字母+特殊字符的组合'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      userInfo: {
        phone: '',
        password: '',
        password2: '',
        yzm: ''
      },
      mInterval: '',
      yzmText: '获取验证码',
      formRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validatePhone, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }],
        password2: [{ required: true, message: '请再次输入密码', trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }],
        yzm: [{ required: true, message: '请输入验证码', trigger: 'blur' },
        { len: 6, message: '验证码为6位数字', trigger: 'blur' }],
      },
    }
  },
  computed: {
    canRegister () {
      if (this.userInfo.phone && this.userInfo.password && this.userInfo.password2 && this.userInfo.yzm) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    initInterval () {
      let djs = 60;
      this.yzmText = djs + ' s';
      this.mInterval = setInterval(() => {
        djs--;
        if (djs == 0) {
          clearInterval(this.mInterval);
          this.mInterval = null;
          this.yzmText = '获取验证码';
        } else {
          this.yzmText = djs + ' s';
        }
      }, 1000);
    },
    getYzm () {
      if (this.mInterval) return;
      if (this.userInfo.phone == '') {
        this.$message.error('请输入手机号！');
        return;
      }
      this.loading = true;
      let api = 'api/Platform/IntegrationUserAuth/SendNetVerifyCode/';
      let params = {
        phone: this.$aes.encrypt(this.userInfo.phone)
      };
      this.$request.get(api, { params: params })
        .then((response) => {
          this.loading = false;
          if (response.code === '000000') {
            this.$message.info('验证码已发送,注意查收！');
            this.initInterval();
          } else {
            this.$message.info(response.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message.error('验证码获取失败！请稍后重试！');
          this.loading = false;
        });
    },
    toLogin () {
      this.$router.push('/wxlogin');
    },
    submitForm () {
      this.$refs.userInfo.validate((valid) => {
        if (valid) {
          this.submitUserInfo();
        } else {
          return false;
        }
      });
    },
    submitUserInfo () {
      this.loading = true;
      let param = {
        phone: this.$aes.encrypt(this.userInfo.phone),
        password: this.$aes.encrypt(this.userInfo.password),
        code: this.$aes.encrypt(this.userInfo.yzm),
      };
      this.$request.post('api/Platform/IntegrationUserAuth/UpdateUserPwd/', param).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          this.$message.success('密码重置成功！')
          this.$router.push('/wxlogin');
        } else {
          this.$message.error(response.message);
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
        });
    },
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}
a.link,
a.link:hover {
  color: #42c3af;
}
a.link:hover {
  text-decoration: underline;
}
.text-btn {
  text-align: center;
  margin-top: 0px;
  font-size: 13px;
  color: #42c3af;
  cursor: pointer;
}
.text-btn:hover {
  text-decoration: underline;
}

.forgot_pwd_css {
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 550px;
  background-image: url(../../public/img/loginbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .input-form {
    padding: 20px 20px;
    .myform .el-input__inner {
      letter-spacing: 1px;
      font-size: 14px;
      padding-left: 45px;
      padding-right: 20px;
      border-radius: 25px;
      background-color: #f7f8fa;
    }
    .myform .el-input__prefix {
      left: 20px;
    }
    .myform .el-button {
      border-radius: 25px;
    }
    .myform .el-form-item__error {
      left: 35px;
    }
  }
  .tab-bar-item {
    line-height: 50px;
    font-size: 18px;
    color: #333;
  }

  .register-box {
    text-align: left;
    padding: 0px 40px;
  }
}
</style>
